import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const luckyBoxVuex = createNamespacedHelpers("luckybox");
const userVuex = createNamespacedHelpers("user");
const assetsVuex = createNamespacedHelpers("assets");
import vailcode from "@utils/errcode";
export default {
  name: "quest",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...luckyBoxVuex.mapState(["luckyBoxList", "selectTab", "luckyBoxInfo"]),
    ...userVuex.mapState(["userData"]),
    ...assetsVuex.mapState(["assetsList"])
  },
  data() {
    return {
      itemData: {},
      selectItemIndex: -1,
      isFlag: true,
      popTipShow: false,
      popRankingShow: false,
      popRecordsShow: false,
      popRecordsInfoShow: false,
      logId: 0,
      countDown: 0,
      roundStatusTime: null,
      isPopRewardResultShow: false,
      selectRow: null,
      lastBuyTime: 0,
      statusTimer: null,
      popDiamondShow: false,
      popNewRoundShow: false,
      popStarDepositShow: false
    };
  },
  watch: {
    "selectTab": {
      async handler(newVal, oldVal) {
        if (newVal != oldVal && newVal >= 0) {
          await this.getItemData();
          await this.getLuckyBoxInfo(this.itemData.id);
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => {
            this.getStatus();
          }, 5000);
        }
      },
      deep: true,
      immediate: false
    }
  },
  beforeRouteLeave(to, from, next) {
    this.selectItemIndex = -1;
    this.isFlag = true;
    this.popTipShow = false;
    this.popRankingShow = false;
    this.popRecordsShow = false;
    this.popRecordsInfoShow = false;
    this.isPopRewardResultShow = false;
    this.popDiamondShow = false;
    this.popNewRoundShow = false;
    this.popStarDepositShow = false;
    this.$loading.hide();
    clearTimeout(this.roundStatusTime);
    clearTimeout(this.statusTimer);
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    ...luckyBoxVuex.mapActions(["getLuckyBoxList", "getLuckyBoxInfo", "getLuckyBoxStatus"]),
    ...luckyBoxVuex.mapMutations(['setSelectTab', 'setLuckyBoxInfo']),
    ...userVuex.mapMutations(['setUserData']),
    ...assetsVuex.mapActions(["getAssetsList"]),
    jumpTo(url) {
      this.$router.push(url);
    },
    onTap(item, index) {
      if (item.status == 0) return;
      this.selectItemIndex = -1;
      this.setSelectTab(index);
    },
    getItemData() {
      this.luckyBoxList.map((item, index) => {
        if (index == this.selectTab) {
          this.itemData = item;
        }
      });
    },
    async onBuy() {
      let time = parseInt(new Date().getTime() / 1000);
      if (this.lastBuyTime && time - 3 < Number(this.lastBuyTime)) {
        this.$toasted.error("Buy cooldown:3s");
        return;
      }
      this.lastBuyTime = time;
      if (!this.isFlag) return;
      if (this.luckyBoxInfo.round.status != 1 || this.luckyBoxInfo.max_buy_count > 0 && this.luckyBoxInfo.max_buy_count <= this.luckyBoxInfo.user.round.user_buy_count) {
        return false;
      }
      if (this.selectItemIndex == -1) {
        this.$toasted.error('Please select a box');
        return false;
      }
      clearTimeout(this.statusTimer);
      this.isFlag = false;
      let itemId = this.luckyBoxInfo.items[this.selectItemIndex].id;
      this.$loading.show();
      let rs = await this.$http.post("/lucky/box/buy", {
        boxId: this.itemData.id,
        itemId,
        count: 1
      });
      setTimeout(() => {
        this.$loading.hide();
        this.isFlag = true;
        this.selectItemIndex = -1;
        vailcode(rs, async () => {
          await this.setLuckyBoxInfo(rs.data);
          if (rs.data.user && rs.data.user.info) {
            this.setUserData(rs.data.user.info);
          }
          this.statusTimer = setTimeout(() => {
            this.getStatus();
          }, 5000);
        });
      }, 3000);
    },
    onRanking() {
      this.popRankingShow = true;
    },
    onRecords() {
      this.popRecordsShow = true;
    },
    onAccept() {
      this.isPopRewardResultShow = false;
      if (this.luckyBoxInfo.round.status >= 4) {
        this.selectRow = null;
        this.statusTimer = setTimeout(() => {
          this.currentInfo();
        }, 1000);
      } else if (this.luckyBoxInfo.round.status >= 2) {
        this.statusTimer = setTimeout(() => {
          this.getStatus();
        }, 5000);
      }
    },
    async getStatus() {
      clearTimeout(this.statusTimer);
      await this.getLuckyBoxStatus({
        roundNo: this.luckyBoxInfo.round.round_no,
        boxId: this.luckyBoxInfo.round.box_id
      });
      if (this.luckyBoxInfo.round.status >= 2) {
        if (!this.selectRow || this.selectRow && this.selectRow.id != this.luckyBoxInfo.round.id) {
          this.roundStatusTime = setTimeout(() => {
            this.checkRoundStatus(this.luckyBoxInfo.round.id);
          }, 1000);
        } else if (this.luckyBoxInfo.round.status >= 4 && this.isPopRewardResultShow == false) {
          this.getLuckyBoxInfo(this.itemData.id);
        }
      } else {
        this.statusTimer = setTimeout(() => {
          this.getStatus();
        }, 5000);
      }
    },
    async checkRoundStatus(roundId) {
      clearTimeout(this.roundStatusTime);
      let rs = await this.$http.post('/lucky/box/winning/status', {
        roundId
      });
      if (rs.code == 0 && rs.data.status == 1) {
        if (rs.data.winning_amount > 0) {
          this.selectRow = {
            id: rs.data.id,
            value: rs.data.winning_amount.toFixed(2),
            unit: this.itemData.currency,
            type: this.itemData.currency.toLowerCase()
          };
          if (this.selectRow.unit == 'TAP') {
            this.selectRow.unit = 'TAPS';
          }
          this.isPopRewardResultShow = true;
        } else {
          if (this.luckyBoxInfo.round.status >= 4) {
            this.popNewRoundShow = true;
          } else if (this.luckyBoxInfo.round.status >= 2) {
            this.statusTimer = setTimeout(() => {
              this.getStatus();
            }, 5000);
          }
        }
      } else {
        this.roundStatusTime = setTimeout(() => {
          this.checkRoundStatus(roundId);
        }, 2000);
      }
    },
    toDeposit() {
      if (this.luckyBoxInfo.title == 'TON') {
        this.$router.push('/depositDetail?cid=ton&id=2');
      } else if (this.luckyBoxInfo.title.toLowerCase() == 'stars') {
        this.popStarDepositShow = true;
      }
    },
    hasLength() {
      let l = 0;
      if (this.luckyBoxInfo && this.luckyBoxInfo.price > 0 && this.luckyBoxInfo.round_duration > 0 && this.luckyBoxInfo.round && this.luckyBoxInfo.round.buy_amount > 0) {
        l = parseInt(this.luckyBoxInfo.round.buy_amount / (this.luckyBoxInfo.price * this.luckyBoxInfo.round_duration) * 100);
      }
      return l;
    },
    async currentInfo() {
      await this.getLuckyBoxInfo(this.itemData.id);
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        this.getStatus();
      }, 5000);
    },
    showTip() {
      this.popTipShow = true;
    },
    showDiamondTip() {
      this.popDiamondShow = true;
    },
    openNew() {
      this.selectRow = null;
      this.currentInfo();
    },
    async depositRefresh() {
      await this.getAssetsList();
      if (this.assetsList) {
        this.assetsList.map(item => {
          if (item.symbol.toLowerCase() == this.luckyBoxInfo.user.assets.token.toLowerCase()) {
            let newLuckBoxInfo = this.luckyBoxInfo;
            this.$set(newLuckBoxInfo.user.assets, "balance", item.balance);
            this.setLuckyBoxInfo(newLuckBoxInfo);
          }
        });
      }
    }
  },
  async mounted() {
    await this.getLuckyBoxList({
      palyType: 0,
      roundType: 1
    });
    if (this.luckyBoxList.length > 0) {
      await this.getItemData();
      await this.getLuckyBoxInfo(this.itemData.id);
      if (this.luckyBoxInfo.round.box_id && this.luckyBoxInfo.round.round_no) {
        this.statusTimer = setTimeout(() => {
          this.getStatus();
        }, 5000);
      }
    }
  }
};